import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { VersionListResp } from 'domain/payload/response/version/VersionListResp';
import { VersionDetailResp } from 'domain/payload/response/version/VersionDetailResp';
import { VersionCreateReq } from 'domain/payload/request/version/VersionCreateReq';
import { VersionUpdateReq } from 'domain/payload/request/version/VersionUpdateReq';
import { VersionConfigResp } from 'domain/payload/response/version/VersionConfigResp';

const VersionService = () => {
  const versionList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<VersionListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/app-version/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const versionDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<VersionDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/app-version/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const versionConfig = async (
    token: string
  ): Promise<BaseResponse<VersionConfigResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/app-version/config`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const versionCreate = async (
    token: string,
    request: VersionCreateReq
  ): Promise<BaseResponse<VersionDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/app-version/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const versionUpdate = async (
    token: string,
    request: VersionUpdateReq
  ): Promise<BaseResponse<VersionDetailResp>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/cms/app-version/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const versionDelete = async (
    token: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/app-version/delete`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { versionList, versionDetail, versionConfig, versionCreate, versionUpdate, versionDelete };
};

export default VersionService;